import { ListResponse } from '../domain/lists'
import { useQuery } from 'react-query'
import { CalculatorRepository } from '../domain/calculator.repository'
import { Error } from '../../../shared/domain/error'

export const useList = (repo: CalculatorRepository) => useQuery<ListResponse, Error>(['lists'],
  async () => await repo.getList()
)
